var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCaution = function SvgCaution(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99967 2.01735C8.96893 2.04393 8.91969 2.09743 8.86397 2.19583L2.33426 13.7274C2.26833 13.8438 2.25292 13.9201 2.25041 13.9543C2.2504 13.9544 2.25039 13.9545 2.25038 13.9547C2.28218 13.9721 2.35812 14 2.51465 14H15.4855C15.6421 14 15.718 13.9719 15.7496 13.9545C15.7496 13.9543 15.7496 13.9542 15.7496 13.9541C15.7471 13.9202 15.7318 13.8439 15.6658 13.7274L9.13546 2.19586C9.07973 2.09745 9.03044 2.04394 8.99967 2.01735ZM15.7687 13.9409C15.7688 13.941 15.768 13.942 15.766 13.9436C15.7677 13.9416 15.7687 13.9408 15.7687 13.9409ZM2.23096 13.941C2.23103 13.9409 2.23207 13.9417 2.23384 13.9438C2.23176 13.9421 2.23088 13.941 2.23096 13.941ZM9.00025 0.5C9.65492 0.500296 10.1476 0.93914 10.4407 1.4567L16.971 12.9882C17.27 13.5161 17.3801 14.1662 17.0435 14.7278C16.7099 15.2843 16.089 15.5 15.4855 15.5H2.51465C1.91012 15.5 1.28875 15.2841 0.955538 14.7267C0.619653 14.1648 0.7307 13.515 1.02899 12.9882L7.5587 1.45673C7.85216 0.938485 8.34526 0.499704 9.00025 0.5Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12.875C9.41421 12.875 9.75 12.5392 9.75 12.125C9.75 11.7108 9.41421 11.375 9 11.375C8.58579 11.375 8.25 11.7108 8.25 12.125C8.25 12.5392 8.58579 12.875 9 12.875Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.375C9.41421 5.375 9.75 5.71079 9.75 6.125V9.875C9.75 10.2892 9.41421 10.625 9 10.625C8.58579 10.625 8.25 10.2892 8.25 9.875V6.125C8.25 5.71079 8.58579 5.375 9 5.375Z",
    fill: "#EA4335"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caution.f3f522fd.svg";
export { ForwardRef as ReactComponent };